import { render, staticRenderFns } from "./AppBetalingSucces.vue?vue&type=template&id=44600541&scoped=true&"
import script from "./AppBetalingSucces.ts?vue&type=script&lang=ts&"
export * from "./AppBetalingSucces.ts?vue&type=script&lang=ts&"
import style0 from "./AppBetalingSucces.scss?vue&type=style&index=0&id=44600541&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44600541",
  null
  
)

export default component.exports